import { store, getContext, getElement, withScope } from '@wordpress/interactivity';
const addQueryArgs = window.wp.url.addQueryArgs;
const { apiFetch } = window.wp;

const BASE_QUERY = {
    order: "desc",
    _embed: true,
	_fields: 'id,title,link,excerpt,_links,_embedded,sticky',
};

const { state } = store( 'biom-frontpage-carousel', {
	state: {
        currentPost: 0,
        currentEvent: 0,
        pause: false,
        tab: 'posts',
        get hasEvents() {
            return (state.maxEvents > 0);
        },
        get hasPosts() {
            return (state.maxPosts > 0);
        },
        get nextPost() {
            return (state.currentPost + 1) % state.maxPosts;
        },
        get previousPost() {
            return ((state.currentPost - 1) < 0) ? (state.maxPosts - 1) : (state.currentPost - 1);
        },
        get nextEvent() {
            return (state.currentEvent + 1) % state.maxEvents;
        },
        get previousEvent() {
            return ((state.currentEvent - 1) < 0) ? (state.maxEvents - 1) : (state.currentEvent - 1);
        },
        get changeSlide() {
            const context = getContext();
            if (context.isPostsActive) {
                context.posts = context.posts.map((p, i) => {
                    p.visibility = (i == state.currentPost);
                    p.position_left = (i > state.currentPost);
                    p.position_right = (i < state.currentPost);
                    return p;
                });
            }
            if (context.isEventsActive) {
                context.events = context.events.map((p, i) => {
                    p.visibility = (i == state.currentEvent);
                    p.position_left = (i > state.currentEvent);
                    p.position_right = (i < state.currentEvent);
                    return p;
                });
            }
        },
        get ariaSlide() {
            const context = getContext();
            return "Slide " + context.item.id;
        }
	},
	actions: {
        nextSlide() {
            const context = getContext();
            if (context.isPostsActive) {
                state.currentPost = state.nextPost;
                state.changeSlide;
            }
            if (context.isEventsActive) {
                state.currentEvent = state.nextEvent;
                state.changeSlide;
            }
        },
        previousSlide() {
            const context = getContext();
            if (context.isPostsActive) {
                state.currentPost = state.previousPost;
                state.changeSlide;
            }
            if (context.isEventsActive) {
                state.currentEvent = state.previousEvent;
                state.changeSlide;
            }
        },
        switchSlide() {
            const { ref } = getElement();
            state.currentPost = parseInt(ref.ariaLabel);
            state.changeSlide;
        },
        switchTab(event) {
            const context = getContext();
            state.tab = event.target.id;
            context.isEventsActive = (state.tab == 'events');
            context.isPostsActive = (state.tab == 'posts');
        },
        pauseSlideShow() {
            state.pause = true;
        },
        resumeSlideShow() {
            state.pause = false;
        }
	},
	callbacks: {
        loadPosts: () => {
            const context = getContext();
            if (!state.hasPosts) {
                return;
            }
           
            let sticky_posts = Array();
            let remaining_posts = Array();
            let no_of_remaining_posts = state.maxPosts;
            let queryParams_sticky =
                { ...BASE_QUERY, per_page: state.maxPosts, sticky: true };
            if (state.postCategoryId != 0) {
                queryParams_sticky =
                    { ...queryParams_sticky, categories: state.postCategoryId };
            }
            apiFetch( { path: addQueryArgs( '/wp/v2/posts', queryParams_sticky ) } ).then( ( posts ) => {
                sticky_posts = posts.map((p, i) => {
                    let title = new DOMParser().parseFromString(p.title.rendered, "text/html");
                    let excerpt = p.excerpt.rendered.replace(/<\/?[^>]+(>|$)/g, "");
                    return {
                        id: i,
                        post_id: p.id,
                        title: title.documentElement.textContent,
                        link: p.link,
                        excerpt: excerpt,
                        featuredmedia: p._embedded['wp:featuredmedia'][0].source_url,
                        visibility: (i == state.currentPost),
                        position_left: (i > state.currentPost),
                        position_right: (i < state.currentPost),
                        sticky: true,
                    }
                });
            } ).then( ( posts ) => {
                no_of_remaining_posts = state.maxPosts - sticky_posts.length;
                if (no_of_remaining_posts <= 0) {
                    return;
                }
                let queryParams =
                    { ...BASE_QUERY, per_page: no_of_remaining_posts };
                if (state.postCategoryId != 0) {
                    queryParams =
                        { ...queryParams, categories: state.postCategoryId };
                }
                apiFetch( { path: addQueryArgs( '/wp/v2/posts', queryParams ) } ).then( ( posts ) => {
                    remaining_posts = posts.map((p, i) => {
                        let title = new DOMParser().parseFromString(p.title.rendered, "text/html");
                        let excerpt = p.excerpt.rendered.replace(/<\/?[^>]+(>|$)/g, "");
                        let j = i + sticky_posts.length;
                        return {
                            id: j,
                            post_id: p.id,
                            title: title.documentElement.textContent,
                            link: p.link,
                            excerpt: excerpt,
                            featuredmedia: p._embedded['wp:featuredmedia'][0].source_url,
                            visibility: (j == state.currentPost),
                            position_left: (j > state.currentPost),
                            position_right: (j < state.currentPost),
                            sticky: false,
                     }
                });
                context.posts = sticky_posts.concat(remaining_posts);
            } )} );
        },
        loadEvents: () => {
            const context = getContext();
            if (!state.hasEvents) {
                return;
            }
            const queryParams = { ...BASE_QUERY, per_page: state.maxEvents };
            apiFetch( { path: addQueryArgs( '/wp/v2/dogadanja', queryParams ) } ).then( ( events ) => {
                context.events = events.map((p, i) => {
                    let title = new DOMParser().parseFromString(p.title.rendered, "text/html");
                    let excerpt = p.excerpt.rendered.replace(/<\/?[^>]+(>|$)/g, "");
                    return {
                        id: i,
                        post_id: p.id,
                        title: title.documentElement.textContent,
                        link: p.link,
                        excerpt: excerpt,
                        featuredmedia: p._embedded['wp:featuredmedia'][0].source_url,
                        visibility: (i == state.currentEvent),
                        position_left: (i > state.currentEvent),
                        position_right: (i < state.currentEvent),
                    }
                });
            } );
        },
        initSlideShow: () => {
            setInterval(
                withScope( () => {
                    if (!state.pause) {
                        state.currentPost = state.nextPost;
                        state.currentEvent = state.nextEvent;
                        state.changeSlide;
                    }
                } ),
                3_000
            );
        },
	},
} );
